import React from 'react';
import PostData from '../../data/battles.json';
import LeaderData from '../../data/leaders.json';
import RelatedData from '../../data/related.json';
import { motion, AnimatePresence } from 'framer-motion';
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from 'react-accessible-accordion';

class Mobilenav extends React.Component {
  render() {
    return (
      <motion.div
        className="Mobilenav"
        animate={this.props.mobileRead ? { right: 0 } : { right: -'550' }}
        transition={{ duration: 0.4 }}
      >
        <div className="Mobileclose" onClick={this.props.closeNav}>
          &times;
        </div>
        <Accordion allowZeroExpanded={true} preExpanded={[0]}>
          <AccordionItem>
            <AccordionItemHeading>
              <AccordionItemButton>Battles</AccordionItemButton>
            </AccordionItemHeading>
            <AccordionItemPanel className="battles">
              {PostData.map((postDetail, index) => {
                return (
                  <p
                    data-toggle="collapse"
                    key={index}
                    onClick={() => {
                      this.props.onPin(index);
                    }}
                  >
                    {postDetail.title}
                  </p>
                );
              })}
            </AccordionItemPanel>
          </AccordionItem>
          <AccordionItem>
            <AccordionItemHeading>
              <AccordionItemButton>Generals</AccordionItemButton>
            </AccordionItemHeading>
            <AccordionItemPanel className="generals">
              {LeaderData.map((leaderDetail, index) => {
                return (
                  <p
                    data-toggle="collapse"
                    key={index}
                    onClick={() => {
                      this.props.onLead(index);
                    }}
                  >
                    {leaderDetail.name}
                  </p>
                );
              })}
            </AccordionItemPanel>
          </AccordionItem>
          <AccordionItem>
            <AccordionItemHeading>
              <AccordionItemButton>Learn More</AccordionItemButton>
            </AccordionItemHeading>
            <AccordionItemPanel>
              {RelatedData.map((relatedDetail, index) => {
                return (
                  <a target="_blank" href={relatedDetail.link}>
                    <p data-toggle="collapse">{relatedDetail.title}</p>
                  </a>
                );
              })}
            </AccordionItemPanel>
          </AccordionItem>
        </Accordion>

        <br />
        <br />
      </motion.div>
    );
  }
}

export default Mobilenav;
